import { render, staticRenderFns } from "./Obito.vue?vue&type=template&id=2435ab9a"
import script from "./Obito.vue?vue&type=script&lang=js"
export * from "./Obito.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports